<div class="storage-shell p-2 p-lg-2">
  <div class="storage-card">
    <div class="storage-toolbar">
      <div class="title-group">
        <div class="title-line">
          <span class="title-icon">
            <lucide-icon [img]="BatteryChargingIcon" [size]="16"></lucide-icon>
          </span>
          <div>
            <h1>Charge / Discharge Scheduling</h1>
            <p class="schedule-copy mb-0">Operate BESS across 96 daily blocks with charge, discharge, idle, and bid visibility aligned to the PRD.</p>
          </div>
        </div>
        <div class="subtitle-line">
          <ng-container *ngIf="product() === 'INTRADAY'">
            Current Block:
            <strong>{{ currentBlock() }}</strong>
            <span>(Block {{ currentBlockIndex() }} of {{ totalBlocks }})</span>
          </ng-container>
        </div>
      </div>

      <div class="toolbar-controls">
        <label class="control-field">
          <span>Product</span>
          <select class="form-select" [ngModel]="product()" (ngModelChange)="setProduct($event)">
            <option value="INTRADAY">INTRADAY</option>
            <option value="DAY-AHEAD">DAY-AHEAD</option>
          </select>
        </label>

        <label class="control-field threshold-field">
          <span>Threshold</span>
          <input class="form-control" placeholder="Enter." [ngModel]="threshold()" (ngModelChange)="setThreshold($event)" />
        </label>

        <div class="display-group">
          <span class="display-label">Display:</span>
          <label><input type="checkbox" [ngModel]="displaySoc()" (ngModelChange)="setToggle('soc', $event)" /> SOC %</label>
          <label><input type="checkbox" [ngModel]="displayPower()" (ngModelChange)="setToggle('power', $event)" /> Power (MW)</label>
          <label><input type="checkbox" [ngModel]="displayBidStatus()" (ngModelChange)="setToggle('bidStatus', $event)" /> Bid Status</label>
          <span class="legend charging">Charging</span>
          <span class="legend discharging">Discharging</span>
          <span class="legend idle">Idle</span>
          <span class="legend bid">Bid Placed</span>
        </div>
      </div>
    </div>

    <div class="matrix-scroll" #matrixScroll>
      <table class="matrix-table">
        <thead>
          <tr class="price-row" *ngFor="let market of marketPriceRows(); let first = first">
            <th class="sticky sticky-sno sticky-blank" [class.sticky-blank-main]="first"></th>
            <th class="sticky sticky-plant market-label" [class.market-label-main]="first">
              <div *ngIf="first" class="market-prices-title">Market Prices (₹/kWh)</div>
              <span>{{ market.market }}</span>
            </th>
            <th class="price-cell" *ngFor="let value of market.values">{{ value }}</th>
          </tr>
          <tr class="header-row">
            <th class="sticky sticky-sno header-sno" rowspan="2">S.No</th>
            <th class="sticky sticky-plant header-left" rowspan="2">Plant / Time Block</th>
            <th colspan="4" *ngFor="let hour of hourGroups">{{ hour }}</th>
          </tr>
          <tr class="minute-row">
            <th
              *ngFor="let label of quarterLabels; let index = index"
              #timeBlockHeader
              [class.current-block-head]="product() === 'INTRADAY' && index + 1 === currentBlockIndex()"
            >
              {{ label }}s
            </th>
          </tr>
        </thead>

        <tbody>
          <tr *ngIf="loading()">
            <td class="loading-cell" [attr.colspan]="quarterLabels.length + 2">Loading battery storage system...</td>
          </tr>

          <tr *ngFor="let plant of plants(); let rowIndex = index; trackBy: trackByEntry">
            <td class="sticky sticky-sno sno-cell">{{ rowIndex + 1 }}</td>
            <td class="sticky sticky-plant plant-cell">
              <div class="plant-title">{{ plant.entryId }}</div>
              <div class="plant-meta">{{ plant.powerMw }} MW <span class="soc-chip">SOC {{ plant.soc }}%</span></div>
              <div class="plant-stats">
                <span><strong>Charge</strong> {{ plant.chargeLabel }}</span>
                <span><strong>Revenue</strong> {{ plant.revenueLabel }}</span>
                <span><strong>Profit</strong> {{ plant.profitLabel }}</span>
              </div>
            </td>

            <td
              *ngFor="let cell of plant.cells"
              class="schedule-cell"
              [class.cell-charging]="cell.state === 'charging'"
              [class.cell-discharging]="cell.state === 'discharging'"
              [class.cell-idle]="cell.state === 'idle'"
              [class.cell-bid]="cell.state === 'bid'"
            >
              <div class="cell-state">
                <span class="status-dot"></span>
                <span *ngIf="displayBidStatus()">{{ cell.state | titlecase }}</span>
              </div>
              <div class="cell-value" *ngIf="displaySoc()">{{ cell.soc }}%</div>
              <div class="cell-value" *ngIf="displayPower()">{{ plant.powerMw }} MW</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
